import { type NumberedFeatureCard } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards.types';

export const PRICING_RELATED: NumberedFeatureCard[] = [
  {
    num: '01',
    tag: 'Sourcing',
    title: 'Where every record comes from',
    description: 'Registry by registry, with attribution and refresh cadence.',
    href: 'https://www.globaldatabase.com/data-sources',
  },
  {
    num: '02',
    tag: 'Reference',
    title: 'The data dictionary',
    description: 'Every field, format and identifier documented for your engineers.',
    href: 'https://www.globaldatabase.com/data-dictionary',
  },
  {
    num: '03',
    tag: 'Comparison',
    title: 'Global Database vs Dun & Bradstreet',
    description: 'Direct sourcing, redistribution rights and provenance compared.',
    href: 'https://www.globaldatabase.com/global-database-vs-dnb',
  },
  {
    num: '04',
    tag: 'Use case',
    title: 'Business verification (KYB)',
    description: 'Verifying entities against 400+ government registries.',
    href: 'https://www.globaldatabase.com/kyb-verification',
  },
  {
    num: '05',
    tag: 'Use case',
    title: 'UBO & ownership graph',
    description: 'Tracing ultimate owners layer by layer from filings.',
    href: 'https://www.globaldatabase.com/ubo-discovery',
  },
  {
    num: '06',
    tag: 'Evidence',
    title: 'Customers & case studies',
    description: 'How compliance, risk and data teams use it.',
    href: 'https://www.globaldatabase.com/customers',
  },
];
